import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        title: {
            '&&': {
                fontWeight: '400',
                fontSize: `${theme.typography.h3.fontSize}px !important`,
                letterSpacing: theme.typography.h3.letterSpacing,
                color: theme.palette.secondary.dark,
                display: 'flex',
                padding: theme.spacing(4, 0, 2),
            },
        },
    }
})

export default useStyles
